module.exports = __webpack_public_path__ + "static/5-04a5c509bf387e4569829f854ef835e6.jpg";